"use client"

interface TogglePillOption {
  label: string
  value: string
}

interface TogglePillGroupProps {
  /** Available options */
  options: TogglePillOption[]
  /** Currently active value */
  activeValue: string
  /** Selection handler */
  onChange: (value: string) => void
  /** Additional classes on the wrapper */
  className?: string
}

export function TogglePillGroup({
  options,
  activeValue,
  onChange,
  className = "",
}: TogglePillGroupProps) {
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {options.map((option) => {
        const isActive = option.value === activeValue
        return (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
              isActive
                ? "bg-[#ff9951] text-[var(--color-brand-action-text)] shadow-sm"
                : "bg-gray-100 text-gray-500 hover:bg-gray-200"
            }`}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
